import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiArrowRight } = FiIcons;

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?auto=format&fit=crop&q=80" 
          alt="NYC Skyline" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/90 to-slate-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center">
        
        {/* Text Content */}
        <div className="w-full md:w-3/5 text-left md:pr-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block py-1 px-3 rounded-full bg-blue-900/50 border border-blue-500/30 text-blue-300 text-sm font-semibold mb-6 tracking-wide uppercase">
              NYC's Premier IT & Networking Partner
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
              Enterprise-Grade <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">WiFi</span> for NYC Businesses.
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl font-light">
              Clark-Ritchotte Communications upgrades your networking infrastructure, secures your guest wireless, and lowers your monthly internet costs with professional Ubiquiti UniFi installations.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a href="#contact" className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)]">
                Schedule Free Consultation <SafeIcon icon={FiArrowRight} />
              </a>
              <a href="#services" className="flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-white border border-slate-600 px-8 py-4 rounded-md font-bold text-lg transition-all">
                Request a Site Survey
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 text-slate-400 text-sm">
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-blue-500 text-lg" />
                <span>Lower Internet Costs</span>
              </div>
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-blue-500 text-lg" />
                <span>Professional Ubiquiti Installers</span>
              </div>
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-blue-500 text-lg" />
                <span>Local NYC Support</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Hero Imagery/Graphic */}
        <motion.div 
          className="w-full md:w-2/5 mt-16 md:mt-0 hidden lg:block"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
            <div className="absolute inset-0 bg-blue-600/10 mix-blend-overlay z-10"></div>
            <img 
              src="https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&q=80" 
              alt="Server Room Networking" 
              className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
            />
            {/* Overlay UI elements to look techy */}
            <div className="absolute bottom-4 left-4 right-4 bg-slate-900/80 backdrop-blur border border-slate-700 p-4 rounded-xl z-20">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-xs text-slate-400 mb-1">Network Status</div>
                  <div className="text-white font-bold flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                    100% Uptime
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-slate-400 mb-1">Bandwidth</div>
                  <div className="text-cyan-400 font-bold">10 Gbps Active</div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;